import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TitleConfigurations, TitleLineConfigurations } from './title.configurations';
import { CommonModule } from '@angular/common';
import { BadgesComponent } from '../badges/badges.component';
import { SocialMediaButtonsComponent } from '../social-media-buttons/social-media-buttons.component';
import { StripSpecialCharsPipe } from '../strip-special-chars/strip-special-chars.pipe';
import { DynamicContentComponent } from '../../dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss', '../../../app.component.scss'],
  standalone: true,
  imports: [ CommonModule, BadgesComponent, SocialMediaButtonsComponent, StripSpecialCharsPipe, DynamicContentComponent]
})
export class TitleComponent implements OnInit, AfterViewInit {

  @Input()
  public config: TitleConfigurations;

  @Input()
  public lineConfig: TitleLineConfigurations;

  @Input()
  public color = '';

  @Input()
  public position = 'left';

  @Input()
  public showFooter = true;

  @Input()
  public hideDots = false;

  @Input()
  public component;

  @ViewChild('titleContainer', {static: true})
  public titleContainer: any;

  @Output()
  public titleContainerLoaded = new EventEmitter();

  public get lineSizes(): Array<string> {
    if (this.lineConfig) {
      const newLineSizes = [];
      for (let index = 0; index < this.lineConfig.numberOfSections; index++) {
        newLineSizes.push(index == this.lineConfig.sectionIndex ? 'line-big' : 'line-small');
      }
      return newLineSizes;
    }
    return [
      'line-big',
      'line-small',
      'line-small'
    ];
  }

  public lineColor = 'inherit';

  constructor() { }

  ngOnInit() {
    if (!this.config) {
      this.config = <TitleConfigurations> {};
    }
    if (this.config.color) {
      this.color = this.config.color;
    }
    this.lineColor = this.lineConfig?.sectionColor;
  }

  ngAfterViewInit() {
    this.titleContainerLoaded.emit(this.titleContainer);
  }
}
